export function createAuthenticatedWebSocket(accessToken: string): WebSocket {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const url = `${protocol}//${window.location.host}/ws`;
  return new WebSocket(url, ['nopanel.v1', `bearer.${accessToken}`]);
}
